import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { 
  selectChatSessionNameWithSessionId,
  selectChatMessageCapWithSessionId,
  selectChatStageWithSessionId,
 } from '../../slices/chatSlice'
import { configChatSessionSync } from '../../slices/chatThunk'
import { chatStages } from '../../models/ChatStages'

export default function ChatConfigPanel({ setIsChatConfigVisible, sessionId, onChat }) {
  const dispatch = useDispatch();
  const initialSessionName = useSelector(selectChatSessionNameWithSessionId(sessionId));
  const initialStageMessageCap = useSelector(selectChatMessageCapWithSessionId(sessionId));
  const chatStage = useSelector(selectChatStageWithSessionId(sessionId));
  const [sessionName, setSessionName] = useState('');
  const [stageMessageCaps, setStageMessageCaps] = useState({
    invitation: 1,
    connection: 1,
    exchange: 1,
    agreement: 1,
    reflection: 1
  });
  // const [refusalCap, setRefusalCap] = useState(0);

  useEffect(() => {
    setSessionName(initialSessionName);
  }, [initialSessionName])

  useEffect(() => {
    const transformedMessageCaps = Object.keys(initialStageMessageCap).reduce((acc, stage) => {
      acc[stage] = initialStageMessageCap[stage].msgCap;
      return acc;
    }, {});

    setStageMessageCaps(transformedMessageCaps);
  }, [initialStageMessageCap]);

  const handleStageMessageCapChange = (stage, value) => {
    setStageMessageCaps(prevCaps => ({ ...prevCaps, [stage]: Number(value) }));
  };

  const onSave = (config) => {
    dispatch(configChatSessionSync({...config, sessionId, onChat}))
    setIsChatConfigVisible(false);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      sessionName,
      messageCap: stageMessageCaps,
    });
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center z-50">
      <div className="absolute inset-0 bg-black opacity-60"></div>

      <div className="relative bg-[#333333] p-6 rounded-lg shadow-lg max-w-md w-full text-white">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-white text-base font-bold mb-3" htmlFor="sessionName">
              Session Name
            </label>
            <input
              className="w-full p-2 bg-[#1e1e1e] text-white rounded-md focus:outline-none focus:border focus:border-[#555]"
              id="sessionName"
              type="text"
              placeholder="Enter Session Name"
              value={sessionName}
              onChange={(e) => setSessionName(e.target.value)}
            />
          </div>

          <hr className="my-2 border-gray-600" />

          <div>
            <label className="block text-white text-base font-bold mb-3">
              Message Caps
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
              {Object.entries(stageMessageCaps).map(([stage, cap]) => {
                const isStageBeforeCurrent = chatStages.indexOf(stage) < chatStages.indexOf(chatStage);

                return (
                  <div key={stage} className="flex flex-col">
                    <span className={`text-gray-300 text-xs font-bold capitalize mb-3 ${isStageBeforeCurrent ? 'opacity-50' : ''}`}>
                      {stage}
                    </span>
                    <input
                      className={`p-2 bg-[#1e1e1e] text-white rounded-md focus:outline-none focus:border focus:border-[#555] ${isStageBeforeCurrent ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#292929]'}`}
                      type="number"
                      min="0"
                      value={cap}
                      disabled={isStageBeforeCurrent}
                      onChange={(e) => handleStageMessageCapChange(stage, e.target.value)}
                    />
                  </div>
                )
              })}
            </div>
          </div>

          {/* <hr className="my-2 border-gray-600" />

          <div className="mb-4">
            <label className="block text-white text-base font-bold mb-3" htmlFor="refusalCap">
              Refusal Cap
            </label>
            <input
              className="w-full p-2 bg-[#1e1e1e] text-white rounded-md focus:outline-none focus:border focus:border-[#555]"
              id="refusalCap"
              type="number"
              placeholder="Enter Refusal Cap"
              value={refusalCap}
              onChange={(e) => setRefusalCap(e.target.value)}
            />
          </div> */}

         
          <div className="flex justify-between mt-4">
            <button
              className="mt-5 px-6 py-2 bg-[#1e1e1e] text-white border border-white rounded-lg hover:bg-[#444] focus:outline-none focus:border-[#555]"
              type="submit"
            >
              Save
            </button>

            <button
                onClick={() => setIsChatConfigVisible(false)}
                className="mt-5 px-6 py-2 bg-[#1e1e1e] text-white border border-white rounded-lg hover:bg-[#444] focus:outline-none focus:border-[#555]"
            >
              Close
            </button>
          </div>
        </form>

      </div>
    </div>
  );
}
